module.exports = __webpack_public_path__ + "static/media/image_partners_philips.7709daf3.jpg";